/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PF Appointments API
 * appointments-api v1. Generated from the route table; do not edit by hand (pnpm openapi).
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod'

export const BookingLink = zod.object({
  embedCode: zod.string(),
  link: zod.string(),
  token: zod.string().nullable().describe('`v1.<payload>.<sig>`; null when no preset is chosen.'),
})

export type BookingLink = zod.input<typeof BookingLink>
export type BookingLinkOutput = zod.output<typeof BookingLink>
